import * as Types from '../types-api.generated';

import { MomentOverviewFragment, MomentFragment, UserLightFragment, WorldOverviewFragment, WorldOverviewOnExhibition, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, TokenFragment, NftIdentifiersFragment, AuctionFragment, SaleFragment, SplitFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiMomentByNftVariables = Types.Exact<{
  chainId: Types.Scalars['ChainId'];
  contractAddress: Types.Scalars['Address'];
  tokenId: Types.Scalars['Int'];
}>;


export type ApiMomentByNft = { moment: { id: number, name: string, description: string | null, worldId: number, posterUrl: string, startsAt: string, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } } | null };



export const ApiMomentByNftDocument = /*#__PURE__*/ `
    query MomentByNft($chainId: ChainId!, $contractAddress: Address!, $tokenId: Int!) {
  moment(
    by: {nft: {chainId: $chainId, contractAddress: $contractAddress, tokenId: $tokenId}}
  ) {
    ...MomentOverviewFragment
  }
}
    ${MomentOverviewFragment}
${MomentFragment}
${UserLightFragment}
${WorldOverviewFragment}`;

export const useMomentByNft = <
      TData = ApiMomentByNft,
      TError = ClientError
    >(
      variables: ApiMomentByNftVariables,
      options?: Omit<UseQueryOptions<ApiMomentByNft, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiMomentByNft, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiMomentByNft, TError, TData>(
      {
    queryKey: ['MomentByNft', variables],
    queryFn: apiFetcher<ApiMomentByNft, ApiMomentByNftVariables>(ApiMomentByNftDocument, variables),
    ...options
  }
    )};

useMomentByNft.getKey = (variables: ApiMomentByNftVariables) => ['MomentByNft', variables];

export const useInfiniteMomentByNft = <
      TData = InfiniteData<ApiMomentByNft>,
      TError = ClientError
    >(
      variables: ApiMomentByNftVariables,
      options: Omit<UseInfiniteQueryOptions<ApiMomentByNft, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiMomentByNft, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiMomentByNft, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MomentByNft.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiMomentByNft, ApiMomentByNftVariables>(ApiMomentByNftDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMomentByNft.getKey = (variables: ApiMomentByNftVariables) => ['MomentByNft.infinite', variables];


useMomentByNft.fetcher = (variables: ApiMomentByNftVariables, options?: RequestInit['headers']) => apiFetcher<ApiMomentByNft, ApiMomentByNftVariables>(ApiMomentByNftDocument, variables, options);
